<template>
  <div class="l-row">
    <form-group :label="`${$t('category.label')} > Ecommerce Moovin`">
      <multiselect
        v-model="newItem.from.category"
        :options="from.categories"
        selectLabel=""
        selectedLabel=""
        placeholder="Escolha"
      />
    </form-group>

    <div class="l-col-1@md vertical-center">
      <i class="i-arrow icon-arrow-right center"></i>
    </div>

    <form-group :label="`${$t('category.label')} > Marketplace MaisCorreios`" :columns="4">
      <multiselect
        v-model="newItem.to.category"
        :options="to.categories"
        selectLabel=""
        selectedLabel=""
        placeholder="Escolha"
      />
    </form-group>

    <slot/>
  </div>
</template>

<script>
  import { cloneDeep } from 'lodash'
  import Panel from '@/components/template/Panel'
  import FormGroup from '@/components/template/FormGroup'
  import api from '@/api'
  import notifier from '@/notifier'
  import Multiselect from 'vue-multiselect'

  export default {
    data: () => ({
      from: {
        categories: []
      },
      to: {
        categories: []
      },
      newItem: {
        from: {
          category: null
        },
        to: {
          category: null
        }
      },
      items: [],
      // category: null,
      alreadyExists: false,
      showProductTypes: false,
      cloneCategories: null,
      loaderCategoriesEcommerce: true,
      loaderCategoriesMarketplace: true
    }),
    props: {
      preset: {
        type: Object,
        required: true
      }
    },
    mounted () {
      this.$emit('loading', true)

      api.getCategories(this.preset.from.module.type, this.preset.from.module.identifier)
        .then(categories => {
          this.from.categories = categories
          this.loaderCategoriesEcommerce = false
          this.hideItem()
          this.$emit('loading', this.loaderCategoriesEcommerce || this.loaderCategoriesMarketplace)
        })
        .catch(() => notifier.error('Impossível carregar as categorias da Moovin.', 'Erro'))

      api.getCategories('marketplace', 'maisCorreios')
        .then(categories => {
          this.to.categories = categories
          this.loaderCategoriesMarketplace = false
          this.$emit('loading', this.loaderCategoriesEcommerce || this.loaderCategoriesMarketplace)
        })
        .catch(() => notifier.error('Impossível carregar as categorias da MaisCorreios.', 'Erro'))
    },
    methods: {
      hideItem () {
        if (!this.cloneCategories) {
          this.cloneCategories = cloneDeep(this.from.categories)
        }

        this.from.categories = cloneDeep(this.cloneCategories)

        for (let i in this.preset.items) {
          const item = this.preset.items[i]

          const index = this.from.categories.indexOf(item.from.category)
          if (index !== -1) {
            this.from.categories.splice(index, 1)
          }
        }
      },
      addPresetItem () {
        this.$emit('loading', true)

        this.alreadyExists = false

        const item = {
          from: {
            category: this.newItem.from.category
          },
          to: {
            category: this.newItem.to.category
          }
        }

        const itemExist = this.preset.items.filter(
          itemPreset => (
            itemPreset.from.category === item.from.category && itemPreset.to.categories === item.to.categories
          )
        )

        if (itemExist.length) {
          notifier.error('Esta predefinição já foi cadastrada.', 'Erro')
          this.alreadyExists = true
          this.$emit('loading', false)
          return false
        }

        this.preset.items.push(item)

        this.$emit('loading', false)
      },
      formatPreset () {
        return {
          'from': {
            'type': this.preset.from.type,
            'identifier': this.preset.from.identifier
          },
          'to': {
            'type': this.preset.to.type,
            'identifier': this.preset.to.identifier
          },
          'type': this.preset.type,
          'item': this.newItem
        }
      },
      emitEnabledAdd () {
        this.$emit('addItemEnable')
      }
    },
    watch: {
      'preset.items' (value) {
        this.items = value

        this.hideItem()
      },
      'newItem.from.category' () {
        this.emitEnabledAdd()
      },
      'newItem.to.category' () {
        this.emitEnabledAdd()
      }
    },
    components: {
      Panel,
      FormGroup,
      Multiselect
    }
  }
</script>

<style lang="sass" scoped>
  .center
    margin: 0 auto

  .vertical-center
    display: flex
    align-items: center
    min-height: 81px
</style>



// WEBPACK FOOTER //
// CategorizationAddItem.vue?263d7120